import gql from "graphql-tag";

export const GET_MANUAL_TEXTS = gql`
  query texts($gridName: GridName) {
    texts(gridName: $gridName) {
      id
      gridName
      poznamka
      createdAt
      code
      markdown
      text_cs
      text_cs_html
      relatedToEntity
      text_en
    }
    enumerations(type: TEMA_MANUALU) {
      id
      text
      value
    }
  }
`;

export const GET_SINGLE_MANUAL_TEXT = gql`
  query textById($id: Float!) {
    textById(id: $id) {
      id
      code
      relatedToEntity
      markdown
      text_cs
      text_cs_html
      createdAt
      poznamka
    }
    enumerations(type: TEMA_MANUALU) {
      id
      text
      value
    }
  }
`;
